const getTacticName = (tactic, t) => {
    const TACTICS = [
        { 'reconnaissance': t('Reconnaissance') },
        { 'resource-development': t('Resource Development') },
        { 'initial-access': t('Initial Access') },
        { 'execution': t('Execution') },
        { 'persistence': t('Persistence') },
        { 'privilege-escalation': t('Privilege Escalation') },
        { 'defense-evasion': t('Defense Evasion') },
        { 'credential-access': t('Credential Access') },
        { 'discovery': t('Discovery') },
        { 'lateral-movement': t('Lateral Movement') },
        { 'collection': t('Collection') },
        { 'command-and-control': t('Command and Control') },
        { 'exfiltration': t('Exfiltration') },
        { 'impact': t('Impact') },
    ];

    const tacticsFiltered = TACTICS.filter((value) => {
        const valueKey = Object.keys(value)[0];
        return tactic.indexOf(valueKey) > -1;
    });

    const tacticsProcessed = tacticsFiltered.reduce((info, value) => {
        return info.concat(Object.values(value));
    }, []) || [];

    return tacticsProcessed;
};

const addAnchorTags = (data) => {
    // eslint-disable-next-line no-useless-escape
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return data.replace(urlRegex, (url) => {
        return `<a href='${url}' rel='noopener noreferrer' target='_blank'>${url}</a>`;
    });
};

export default (t) => {
    return [
        {
            header: t('ID'),
            accessor: 'id'
        },
        {
            header: t('Tactics'),
            accessor: 'tactics',
            parser: (data) => getTacticName(data, t)
        },
        {
            header: t('Permissions Required'),
            accessor: 'permissionsRequired'
        },
        {
            header: t('Description'),
            accessor: 'description',
            parser: (data) => addAnchorTags(data)
        }
    ];
};
